import * as React from 'react';
import { connect } from 'react-redux';
import { CalendarAppState } from '../classes/redux-states';
import { CalendarApiModel } from '../redux/reducers/calendar-api';
import { Dispatch } from 'redux';
import CalendarListViewComponent from './calendar-list-view';
import CalendarGridViewComponent from './calendar-grid-view';
import NoEventsComponent from './no-events';

interface StateToProps {
    selectedView: string;
    noEvents: boolean;
}

interface CalendarViewContainerState {
    isMobile: boolean;
}

type CalendarViewContainerProps = StateToProps;

export class CalendarViewContainer extends React.Component<CalendarViewContainerProps, CalendarViewContainerState> {
    constructor(props: CalendarViewContainerProps) {
        super(props);

        this.state = {
            isMobile: false
        }
    }
    


    render() {

        if (!this.props.noEvents) {
            return (
                <div>
                    {
                        this.props.selectedView === "list-view" || this.state.isMobile ? <CalendarListViewComponent /> : <CalendarGridViewComponent />
                    }
                </div>  
            )
        } else {
            return (
                <NoEventsComponent />
            )
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({
            isMobile: window.innerWidth <= 768
        });
    }
}

function mapStateToProps(state: CalendarAppState): StateToProps {
    return {
        selectedView: state.calendarApiModel.selectedView,
        noEvents: state.calendarApiModel.noEvents
    }
}

export default connect(mapStateToProps, null)(CalendarViewContainer);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/calendar-view-container.tsx